import moment from "moment";
import React, { useContext, useEffect, useState, useRef } from "react";
import { Form, OverlayTrigger, Table, Tooltip, Modal, Button, Tab, Tabs } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { AiOutlineFunction, AiFillFileExcel } from "react-icons/ai";
import { BiPencil } from "react-icons/bi";
import { BsXSquare, BsThreeDotsVertical, BsFileEarmarkFill, BsX, BsDownload } from "react-icons/bs";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { FcFinePrint } from "react-icons/fc";
import { toast } from "react-toastify";
import { LoaderContext, RegulationContext } from "../../../App";
import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal";
import { BACKSPACE_EVT_KEY, DELETE_EVT_KEY, DataViewCategoryType, LS_DV_FILTER_KEY } from "../../../core/constants/common";
import KPIService from "../../../core/service/KPIService";
import StandardService from "../../../core/service/StandardService";
import SubStdService from "../../../core/service/SubStdService";
import Utils from "../../../core/utilities/Utils";
import refresh_icon from '../../../images/refresh_icon.png';
import KPIDataView from "../KPI/KPIDataView";
import CompareDataView from "./CompareDataView/CompareDataView";
import './DataView.scss';
import DataViewFilter from "./DataViewFilter";
import DataViewHeaderActions from "./DataViewHeaderActions";
import KPIActionsView from "../KPI/KPIActionsView";
import QualitativeDataView from "./PeriodicDataView/QualitativeDataView";
import { useNavigate, useParams } from "react-router-dom";

const DataViewReporting = ({ t, yearFilter, onDataUpdate, type = 'ESG_REPORTING' }) => {

	const dvFilter = JSON.parse(localStorage.getItem(LS_DV_FILTER_KEY));
	const { glbRegulation } = useContext(RegulationContext);
	const glbRegulationId = glbRegulation?.id ?? "";
	const month = Utils.getMonthFromFrequency(glbRegulation.frequency);
	const year = new Date().getFullYear();
	const { setLoaderDisplay } = useContext(LoaderContext);
	const { goalId } = useParams();

	const [filter, setFilter] = useState({
		reportingPeriod: yearFilter ? `${yearFilter}-01-01` : dvFilter?.reportingPeriod ?? `${year}-${month}-01`,
		categoryType: dvFilter?.categoryType ?? DataViewCategoryType.ENVIRONMENTAL,
		topicIds: dvFilter?.topicIds ?? null,
		metricIds: dvFilter?.metricIds ?? null,
		businessUnitIds: dvFilter?.businessUnitIds ?? null,
		parentEntities: dvFilter?.parentEntities ?? null,
		childEntities: dvFilter?.childEntities ?? null,
		periodFrom: null,
		periodTo: null,
		groupIds: dvFilter?.groupIds ?? null,
		kpiCategory: '',
		goalId: goalId ?? '',
		kpiId: '',
		entityId: ''
	});
	const [dataViewData, setDataViewData] = useState([]);
	const [dataPoints, setDataPoints] = useState({});
	const [topicVisibility, setTopicVisibility] = useState({});
	const [dpVisibility, setDPVisibility] = useState({});
	const [metricDPToSave, setMetricDPToSave] = useState([]);
	const [branchColEdited, setBranchColEdited] = useState({});
	const [uomList, setUOMList] = useState([]);
	const [branchDPToSave, setBranchDPToSave] = useState([]);
	const [showBranchDPSaveButton, setShowBranchDPSaveButton] = useState(false);
	const [validation, setValidation] = useState({});
	const [showFilter, setShowFilter] = useState(false);
	const [view, setView] = useState('DATA_VIEW');
	const [validCheck, setValidCheck] = useState('')
	const [editedBranch, setEditedBranch] = useState(null)
	const [viewType, setViewType] = useState(type);
	const [showModal, setShowModal] = useState(false);
	const [attachedFiles, setAttachedFiles] = useState([]);
	const [dpComments, setDPComments] = useState('');
	const [selectedDp, setSelectedDp] = useState({});
	const [fileUploader, setFileUploader] = useState('');
	const [selectedFile, setSelectedFile] = useState({});
	const [showConfirmation, setShowConfirmation] = useState(false);
	const [messageConfirmation, setMessageConfirmation] = useState('');
	const [isCommentEdit, setIsCommentEdit] = useState(false);
	const [tempComments, setTempComments] = useState('');
	const [tempAttachments, setTempAttachments] = useState([]);
	const fileInputRef = useRef();
	const [key, setKey] = useState('quan');
	const [showQual, setShowQual] = useState(false);
	const [showQuan, setShowQuan] = useState(true);
	const [selectedBranchData, setSelectedBranchData] = useState({});
	const navigate = useNavigate();

	useEffect(() => {
		getUOMs();
	}, []);

	useEffect(() => {
		if (!glbRegulationId) return;
		if (showQuan) {
			getDataViewData(filter);
		}
	}, [glbRegulationId]);

	const getDataViewData = (f) => {
		setLoaderDisplay(true);
		StandardService.getMetricsByFilter(glbRegulationId, f.reportingPeriod, f)
			.then(res => {
				setLoaderDisplay(false);
				if (res.status !== 200) return;

				setDataViewData(res.data);
				// If some metric was already in expanded state,
				// then keep its state unchanged unless the topic has changed in the new filter
				let previousTopicExists = false;
				for (let i = 0; i < f.topicIds?.length; i++) {
					const topicId = f.topicIds[i];
					if (filter.topicIds?.indexOf(topicId) < 0) continue;

					previousTopicExists = true;
					break;
				}
				let dpVisibilityData = JSON.parse(JSON.stringify(dpVisibility));
				if (!previousTopicExists && f.topicIds?.length > 0) {
					dpVisibilityData = {};
				}
				setDPVisibility(dpVisibilityData);
				// Refresh datapoints data for the displayed datapoints
				const metricIds = Object.keys(dpVisibilityData);
				if (metricIds?.length == 0) {
					setDataPoints({});
				}

				metricIds?.forEach(metricId => {

					if (!dpVisibilityData[metricId] || dpVisibilityData[metricId] === 'hide') return;

					getDataPoints(+metricId, f);
				});
			}).catch(err => {
				setLoaderDisplay(false);
			});
	};
	const saveChangesConfirmationCallBack = (val) => {
		if (!val) {
			onColCancelEdit(editedBranch)
			setEditedBranch(null)
			return
		}

		saveMetricDataPoint();
		saveBranchDataPoint();
		setEditedBranch(null)
	}
	const getDataPoints = (metricId, f) => {
		const filterToUse = f ? f : filter;
		setLoaderDisplay(true);
		SubStdService.getBranchBasedData(
			glbRegulationId,
			metricId,
			filterToUse.reportingPeriod,
			filterToUse.businessUnitIds,
			filterToUse.periodFrom,
			filterToUse.periodTo,
			filterToUse.groupIds,
		).then((res) => {
			setLoaderDisplay(false);
			if (res.status !== 200) return;

			setDataPoints(existingDPs => {
				existingDPs[metricId] = res.data.dataPoints;
				return existingDPs;
			});
			const vis = { ...dpVisibility };
			vis[metricId] = 'show';
			setDPVisibility(vis);
		})
			.catch((e) => {
				setLoaderDisplay(false);
			});
	};
	const getUOMs = () => {
		StandardService.getUnitsOfMeasure()
			.then(res => {
				if (res.status !== 200) return;

				setUOMList(res.data.data);
			})
			.catch((error) => { });
	};

	const applyFilter = (f) => {
		setFilter(f);
		if (viewType === 'KPI') return;
		if (showQuan) {
			getDataViewData(f);
		}
	};

	const resetData = () => {
		setDataViewData([]);
		setDataPoints({});
	}

	const showOrHideTopic = (topicId) => {
		const vis = { ...topicVisibility };
		vis[topicId] = vis[topicId] === 'hide' ? 'show' : 'hide';
		setTopicVisibility(vis);
	};

	const showOrHideDataPoints = (metricId) => {
		const vis = { ...dpVisibility };
		vis[metricId] = vis[metricId] === 'show' ? 'hide' : 'show';
		setDPVisibility(vis);
		if (vis[metricId] === 'hide') {
			const existingDPs = JSON.parse(JSON.stringify(dataPoints));
			existingDPs[metricId] = [];
			setDataPoints(existingDPs);
			return;
		}
		getDataPoints(metricId);
	};

	const metricDPChanged = (metric, branchId) => (e) => {
		const data = [...metricDPToSave];
		const index = data.findIndex(x => x.metricId === metric.id);
		if (index >= 0) {
			data[index].value = e.target.value;
		} else {
			const dat = {
				id: metric.id,
				value: e.target.value,
				metricId: metric.id,
				branchId: branchId,
			};
			data.push(dat);
		}
		setMetricDPToSave(data);
	};

	const saveMetricDataPoint = () => {
		if (metricDPToSave.length === 0) {
			return
		}
		metricDPToSave?.forEach(dp => {
			dp.value = Utils.parseLocaleNumber(dp.value);
		});
		setLoaderDisplay(true);
		KPIService.saveDataPoint(
			glbRegulationId,
			filter.reportingPeriod,
			{ dataPoints: metricDPToSave }
		).then(res => {
			setLoaderDisplay(false);
			if (res.status !== 200) return;

			toast.success("Success", {
				position: toast.POSITION.TOP_RIGHT,
			});
			setMetricDPToSave([]);
			getDataViewData(filter);
			setDataPoints([]);
			onDataUpdate();
		}).catch((error) => {
			setLoaderDisplay(false);
		});
	};


	const onUOMChange = (branchData, dataPointId) => (e) => {
		const data = [...branchDPToSave];
		const index = data.findIndex((x) => ((x.branchId === branchData.branchId) && (x.dataPointId === dataPointId)));
		if (index >= 0) {
			data[index].uom = e.target.value;
		} else {
			const dat = {
				id: branchData.id,
				value: branchData?.valueBeforeConversion ? branchData?.valueBeforeConversion : branchData?.value,
				dataPointId: dataPointId,
				branchId: branchData.branchId,
				uom: e.target.value,
				remark: branchData.remark,
				attachments: branchData.attachments ? branchData.attachments : []
			};
			data.push(dat);
		}
		setBranchDPToSave(data);
	};

	const branchDPChanged = (branchData, dataPointId) => (e) => {
		const data = [...branchDPToSave];
		const index = data.findIndex((x) => ((x.branchId === branchData.branchId) && (x.dataPointId === dataPointId)));
		if (index >= 0) {
			data[index].value = e.target.value;
		} else {
			const dat = {
				id: branchData.id,
				value: e.target.value,
				dataPointId: dataPointId,
				branchId: branchData.branchId,
				uom: branchData.uomBeforeConversion ? branchData?.uomBeforeConversion : branchData?.uom,
				remark: branchData.remark,
				attachments: branchData.attachments ? branchData.attachments : []
			};
			data.push(dat);
		}
		setBranchDPToSave(data);
	};
	const handleKeyPress = (event) => {
		// Allow only numbers, decimal point and comma
		if (!(event.key === BACKSPACE_EVT_KEY || event.key === DELETE_EVT_KEY || /^[0-9.,]+$/.test('' + event.key))) {
			event.preventDefault();
		}
	};

	const saveBranchDataPoint = async (e) => {
		if (branchDPToSave.length === 0) {
			setBranchColEdited({});
			return;
		}
		let isValid = true;
		let validationClone = JSON.parse(JSON.stringify(validation));
		for (let i = 0; i < branchDPToSave.length; i++) {
			const dp = branchDPToSave[i];
			if (dp.value && !dp.uom) {
				isValid = false;
				setValidCheck(true)
				break;
			}
			if (dp.value == '' && dp.uom == '') {
				setValidCheck(false)
			}


		}
		// Iterate all for form field validation		
		for (let i = 0; i < branchDPToSave.length; i++) {
			const dp = branchDPToSave[i];
			validationClone[`b-${dp.branchId}`] = true;
			validationClone[`d-${dp.dataPointId}`] = true;
		}
		setValidation(validationClone);
		if (!isValid) {
			toast.error(t("UnitNotSelected.label"), {
				position: toast.POSITION.TOP_RIGHT,
			});
			return;
		}
		branchDPToSave?.forEach(dp => {
			dp.value = Utils.parseLocaleNumber(String(dp.value));
		});
		setLoaderDisplay(true);
		SubStdService.saveBranchDataPoint(
			glbRegulationId,
			filter.reportingPeriod,
			{ dataPoints: branchDPToSave }
		).then(res => {
			setLoaderDisplay(false);
			if (res.status !== 200) return;

			toast.success("Success", {
				position: toast.POSITION.TOP_RIGHT,
			});
			setBranchColEdited({});
			setBranchDPToSave([]);
			getDataViewData(filter);
			setDataPoints([]);
			setValidation({});
			onDataUpdate();
		}).catch((error) => {
			setLoaderDisplay(false);
		});
	};

	const onColEdit = (branchId) => {
		if (!branchId) {
			return;
		} else {
			const vis = { ...dpVisibility };
			let exists = Object.values(vis).includes("show");

			if (!exists) {
				toast.warning("Please open a metric to edit", {
					position: toast.POSITION.TOP_RIGHT,
				});
			} else {
				const bData = { ...branchColEdited };
				bData[branchId] = true;
				setBranchColEdited(bData);
				setShowBranchDPSaveButton(true);
			}
		}
	};

	const onColCancelEdit = (branchId) => {
		if (!branchId) return;

		const bData = { ...branchColEdited };
		bData[branchId] = false;
		setBranchColEdited(bData);
		setShowBranchDPSaveButton(false);
	};

	const onCalculateEquation = (metricId) => {
		SubStdService.calculateEquation(metricId, filter.reportingPeriod)
			.then((response) => {
				if (response.data?.data) {
					toast.success(response.data.message, {
						position: toast.POSITION.TOP_RIGHT,
					});
					getDataViewData(filter);
				} else {
					toast.error(response.data.message, {
						position: toast.POSITION.TOP_RIGHT,
					});
				}
			})
			.catch(er => { });
	};

	const hasQuantitativeMetrics = (metrics) => {
		let hasMetrics = false;
		for (let i = 0; i < metrics?.length; i++) {
			const metric = metrics[i];
			if (metric.category === 'QUANTITATIVE') {
				hasMetrics = true;
				break;
			}
		}
		return hasMetrics;
	};

	const getBranchesFromFilteredData = () => {
		let branches = [];
		for (let index = 0; index < dataViewData?.length; index++) {
			const dvData = dataViewData[index];
			if (dvData?.metricData?.length > 0) {
				branches = dvData?.metricData[0].branches;
				break;
			}
		}
		return branches;
	};

	const renderColumnActionIcon = (branchId) => {
		if (view === 'CONSOLIDATED_VIEW') return <></>;

		return (
			<span>
				{
					branchColEdited[branchId]
						?
						<OverlayTrigger
							placement="top"
							overlay={Utils.renderTooltip(t("CancelEdit.label"))}>
							<span>
								<BsXSquare
									className="cursor"
									onClick={() => {
										setEditedBranch(branchId)
									}}></BsXSquare>{" "}
							</span>
						</OverlayTrigger>
						:
						<OverlayTrigger
							placement="top"
							overlay={Utils.renderTooltip(t("Edit.label"))}>
							<span>
								<BiPencil
									className="cursor"
									onClick={() => onColEdit(branchId)} />
							</span>
						</OverlayTrigger>
				}
			</span>
		);
	};

	const renderTableHeader = () => {
		return (
			<thead>
				<tr>
					<th className="">{t("Topics.label")}</th>
					<th className="text-center total-col-header">
						<span className="mx-1">{t("Total.label")}</span>
					</th>
					{
						getBranchesFromFilteredData()?.map((branch, bIndex) => {
							return (
								<th key={`branchHeader-${bIndex}`} className="branch-cell text-center 2">
									<span className="mx-1">{branch.branchName}</span>
									{renderColumnActionIcon(branch.branchId)}
								</th>
							);
						})
					}
				</tr>
			</thead>
		);
	};

	const renderEmptyDataLabel = () => {
		return (
			<tr>
				<td colSpan="2" className="text-center 2">
					<div className="Nodatafound_box">
						<h6><FcFinePrint className="me-2" />{t("Nodatafound.label")}</h6>
					</div>
				</td>
			</tr>
		)
	};

	const noAttachmentLabel = () => {
		return (
			<div>
				<FcFinePrint className="me-2" /> No attachments available!
			</div>
		)
	};

	const renderTopicRow = (topic, index) => {
		return (
			<tr key={`topic-${topic.topicId}-${index}`} className="topic-row">
				<td colSpan={getBranchesFromFilteredData()?.length ? (getBranchesFromFilteredData().length + 2) : 2} className="name-cell 1">
					<span className="DataTopic_sticky">
						<button
							type="button"
							className="mx-2 cursor topic-toggle-button"
							onClick={() => {
								showOrHideTopic(topic.topicId)
							}}
							aria-label={`Toggle ${topic.topicName}`}
						>
							{(topicVisibility[topic.topicId] === 'hide') ? <FaChevronDown /> : <FaChevronUp />}
						</button>
						<span>{topic.topicName}</span>
					</span>
				</td>
			</tr>
		);
	};

	const renderMetricEquationTooltip = (metric) => {
		return (
			<Tooltip className="mytooltip">
				<b>{metric.equation?.expression ?? ''}</b>
			</Tooltip>
		);
	}

	const renderMetricRow = (metric, index, topicId) => {
		if (metric.category === 'QUALITATIVE') return <></>;

		return (
			<tr key={`metric-${metric.id}-${index}`}
				className={topicVisibility[topicId] === 'hide' ? 'metric-row d-none' : 'metric-row'}>
				<td className="name-cell">
					<div>
						<div>
							<button
								type="button"
								className="mx-2 cursor metric-toggle-button"
								onClick={() => showOrHideDataPoints(metric.id)}
								aria-label={`Toggle data points for ${metric.code}`}
							>
								{dpVisibility[metric.id] === 'show' ? <FaChevronUp /> : <FaChevronDown />}
							</button>
							<span><b>{metric.code}:</b> {metric.name}</span>
						</div>
						<div>
							{
								metric.code == "ECD072" &&
								<OverlayTrigger
									placement="top"
									overlay={renderGHGEmissionTooltip()}>
									<button
										type="button"
										className="cursor text-muted metric-action-button"
										onClick={() => gotoEditGHGData()}
										aria-label="Edit GHG data"
									>
										<AiFillFileExcel />
									</button>
								</OverlayTrigger>
							}
							&nbsp;&nbsp;
							<OverlayTrigger
								placement="top"
								overlay={renderMetricEquationTooltip(metric)}>
								<button
									type="button"
									className="cursor text-muted metric-action-button"
									onClick={() => onCalculateEquation(metric.id)}
									aria-label={`Calculate equation for ${metric.code}`}
								>
									<AiOutlineFunction />
								</button>
							</OverlayTrigger>
						</div>
					</div>
				</td>
				<td className="total-cell">
					{
						metric.emissionLinked
							?
							`${Utils.formattedNumber(metric.emissionSolutionInTCO2e) + ' tCO2-e'}`
							:
							(metric.value !== null ? `${Utils.formattedNumber(metric.value)} ${metric.unitOfMeasure}` : 0)
					}
				</td>
				{
					metric.branches?.map((branch, bIndex) => {
						return (
							<td key={`metric-branch-cell-${bIndex}`}
								className={`branch-cell ${filter.parentEntities?.indexOf(branch.branchId) >= 0 ? 'parent-branch-cell' : 'child-branch-cell'}`}>
								{
									metric.emissionLinked
										?
										`${Utils.formattedNumber(branch.emissionSolutionInTCO2e) + ' tCO2-e'}`
										:
										`${Utils.formattedNumber(branch.solution)} ${metric.value !== null ? metric.unitOfMeasure : ''}`
								}
							</td>
						);
					})
				}
			</tr>
		);
	};

	const renderDataPointRows = (metricId) => {
		if (!dataPoints[metricId]) return <></>;

		return (
			dataPoints[metricId]?.map((dataPoint, dIndex) => {
				return (
					<tr key={`dp-${dataPoint.id}-${dIndex}`} className="dp-row">
						<td className="name-cell">
							<span>{dataPoint.name} ({dataPoint.dataPointCode})</span>
						</td>
						<td className="total-cell">
							{
								!dataPoint.emissionLinked ?
									dataPoint.combined !== null ? `${Utils.formattedNumber(dataPoint.combined)} ${dataPoint.unit}` : 0
									:
									`${Utils.formattedNumber(dataPoint.emissionCombinedInTCO2e) + ' tCO2-e'}`
							}
						</td>
						{
							dataPoint.branches?.map((branch, bIndex) => {
								return renderDataPointBranchCell(dataPoint, branch, bIndex);
							})
						}
					</tr>
				)
			})
		);
	};

	const renderDPBranchCellEditableFields = (dataPoint, branch, index) => {
		return (
			<Form validated={validation[`d-${dataPoint.id}`] === true && validation[`b-${branch.branchId}`] === true}>
				<div className='w-100 d-flex'>
					<div className='w-60'>
						<input
							type="text"
							className="form-control branch-col"
							id={`branchValueField-${branch.branchId}-${index}`}
							defaultValue={
								branch?.valueBeforeConversion
									? Utils.formattedNumber(branch?.valueBeforeConversion)
									: Utils.formattedNumber(branch?.value)
							}
							name="value"
							onChange={branchDPChanged(branch, dataPoint.id)}
							onKeyDown={handleKeyPress}
						/>
					</div>

					<select className='form-select w-40'
						id={`branchUOMField-${branch.branchId}-${index}`}
						required={validCheck ? true : false}
						defaultValue={branch.uomBeforeConversion ? branch?.uomBeforeConversion : branch?.uom}
						onChange={onUOMChange(branch, dataPoint.id)}>
						{
							<>
								<option key='' value=''>{t("Select.label")}</option>
								{
									dataPoint?.relevantUoms?.length > 0
										?
										dataPoint?.relevantUoms?.sort((a, b) => a.localeCompare(b))?.map(u => {
											return <option key={u} value={u}>{uomList?.find(l => l.inputUnit === u)?.inputUnitName}</option>;
										})
										:
										uomList?.map(u => {
											return <option key={u.id} value={u.inputUnit}>{u.inputUnit}</option>;
										})
								}
							</>
						}
					</select>
				</div>
				<div>
					<span>
						{branch.valueBeforeConversion ? `${Utils.formattedNumber(branch.valueBeforeConversion)} ${branch.uomBeforeConversion}` : '-'}
					</span>
					{
						!dataPoint.emissionLinked && branch.uomBeforeConversion !== dataPoint.unit &&
						<span className='text-muted mx-1'>{`/ ${Utils.formattedNumber(branch.value)} ${dataPoint.unit}`}</span>
					}
					{
						dataPoint.emissionLinked &&
						<span className='text-muted mx-1'>{`/ ${Utils.formattedNumber(branch.emissionValueInTCO2e)} tCO2-e`}</span>
					}
				</div>
			</Form>
		);
	}

	const renderDataPointBranchCell = (dataPoint, branch, index) => {
		return (
			<td key={`dataPoint-branch-cell-${index}`}
				className={`branch-cell ${filter.parentEntities?.indexOf(branch.branchId) >= 0 ? 'parent-branch-cell' : 'child-branch-cell'}`}>
				{/* <div className="inner_tb"> */}
				<div
					className={`inner_tb ${renderDPBranchCellEditableFields(dataPoint, branch, index) ? 'additional-class-name' : ''}`}
				>
					{

						branchColEdited[branch.branchId] === true
							? <>{renderDPBranchCellEditableFields(dataPoint, branch, index)}</>
							:
							<>
								{
									!dataPoint.emissionLinked ?

										branch.valueBeforeConversion && branch.uomBeforeConversion
											?
											<>
												{/* <span>{`${Utils.formattedNumber(branch.valueBeforeConversion)} ${branch.uomBeforeConversion}`}</span> */}
												<span>{`${Utils.formattedNumber(branch.valueBeforeConversion)} `}</span>
												{
													branch.uomBeforeConversion !== dataPoint.unit &&
													// <span className='text-muted mx-1'>{`(${Utils.formattedNumber(branch.value)} ${dataPoint.unit})`}</span>
													<span className='text-muted mx-1'>{`(${Utils.formattedNumber(branch.value)}`}</span>
												}
											</>
											: `${branch.value !== 0 ? Utils.formattedNumber(branch.value) + ' ' + dataPoint.unit : '0'}`
										:
										// <span className='text-muted mx-1'>{Utils.formattedNumber(branch.emissionValueInTCO2e) + ' tCO2-e'}</span>
										<span className='text-muted mx-1'>{Utils.formattedNumber(branch.emissionValueInTCO2e)}</span>
								}

								{/* {
									branch.value && branch.activity
										? <OverlayTrigger
											placement="top"
											overlay={renderDPBanchCellTooltip(branch)}>
											<span className="Info_dataView">
												<img src={refresh_icon} className="dp-info-icon" />
											</span>
										</OverlayTrigger>
										: ''
								} */}
								{
									<OverlayTrigger
										placement="auto"
										overlay={<Tooltip id="tooltip-like">  {t("CommentsandDocumentsFile.label")}</Tooltip>} >
										<span className="CommentsandDocumentsFile_btn" onClick={() => showCommentsAndUploads(dataPoint, branch, index)}>
											<BsThreeDotsVertical />
										</span>
									</OverlayTrigger>
								}
							</>
					}
				</div>
			</td>
		);

	};

	const renderDPBanchCellTooltip = (data) => {
		return (
			<Tooltip className="mytooltip">
				<div><b>Source</b> : {data.activity.source}</div>
				<div><b>Last Modified by</b> : {data.activity.lastModifiedBy}</div>
				<div><b>Date</b> : {moment(data.activity.lastModifiedDate).format("MMM Do YYYY, h:mm a")}</div>
			</Tooltip>
		);
	};

	const setTabKey = (k) => {
		setKey(k);
		if (k == 'qual') {
			setShowQual(true);
			setShowQuan(false);
		} else {
			setShowQual(false);
			setShowQuan(true);
			getDataViewData(filter);
		}
	}

	const renderDataViewTable = () => {
		if (viewType === 'ESG_REPORTING') {
			if (view === 'CONSOLIDATED_VIEW') {
				return (
					<div id='dataViewTableHolder 2' >
						<div className="DataView_Tab 1" >
							{showQuan && renderQuantitativeTabContent()}
						</div>
					</div>
				);
			} else {
				return (
					<div id='dataViewTableHolder 2' >
						<div className="DataView_Tab 2" >
							<Tabs
								id="uncontrolled-tab-example"
								className="mb-1"
								activeKey={key}
								onSelect={(k) => setTabKey(k)}>
								<Tab eventKey="quan" title="Quantitative">
									{showQuan && renderQuantitativeTabContent()}
								</Tab>
								{
									(viewType === 'ESG_REPORTING' && view === 'DATA_VIEW') &&
									<Tab eventKey="qual" title="Qualitative">
										{
											showQual &&
											<QualitativeDataView filterData={filter} view={view} viewType={viewType} />
										}
									</Tab>
								}
							</Tabs>
						</div>
					</div>
				);
			}
		} else if (viewType === 'KPI' && view === 'DATA_VIEW') {
			return <KPIDataView filter={filter} />;
		}
	};

	const showCommentsAndUploads = (dataPoint, branch, index) => {
		setShowModal(true);
		let data = {
			dataPointId: dataPoint.id,
			branchId: branch.branchId,
			id: branch.id,
			remark: branch.remark,
			attachments: branch.attachments ? branch.attachments : [],
			value: branch.valueBeforeConversion,
			uom: branch.uomBeforeConversion,
			unit: dataPoint.unit
		}
		setDPComments(branch.remark);
		setAttachedFiles(branch.attachments ? branch.attachments : []);
		setSelectedDp(data);
		setSelectedBranchData({ ...branch, dpName: dataPoint.name, emissionLinked: dataPoint.emissionLinked });
	}

	const handleModalClose = () => {
		setShowModal(false);
		setMessageConfirmation('');
		setSelectedDp({});
		setSelectedBranchData({});
		setDPComments('');
		setAttachedFiles([]);
		setSelectedFile({});
		setIsCommentEdit(false);
		setTempComments('');
		setTempAttachments([]);
	}

	const uploadAttachments = (fileUploaded) => {
		if (fileUploaded) {
			const formData = new FormData();
			formData.append("document", fileUploaded);
			setLoaderDisplay(true);
			SubStdService.uploadAttachments(formData).then(res => {
				setLoaderDisplay(false);
				if (res.status === 200 || res.status === 201) {
					let files = tempAttachments;
					files.push(res.data)
					// setAttachedFiles(files);
					setTempAttachments(files);
					// toast.success("Document uploaded", {
					// 	position: toast.POSITION.TOP_RIGHT,
					// });
					fileInputRef.current.value = null;
				}
			}).catch((error) => {
				setLoaderDisplay(false);
			});
		} else {
			toast.warning('Please select a file');
		}
	}

	const handleFileSelect = (event) => {
		if (event.target.files[0].size <= 1024 * 1024 * 2) {
			const fileUploaded = event.target.files[0];
			uploadAttachments(fileUploaded);
		} else {
			fileInputRef.current.value = null;
			toast.warning('Upload files less than 2MB', {
				position: toast.POSITION.TOP_RIGHT,
				autoClose: 3000
			});
		}
	};

	const saveCommentsAndFiles = () => {
		let existData = selectedDp;
		existData['remark'] = tempComments
		existData['attachments'] = tempAttachments;
		setSelectedDp(existData);
		setLoaderDisplay(true);
		SubStdService.saveBranchCommentsAttachments(
			glbRegulationId,
			filter.reportingPeriod,
			existData
		).then(res => {
			setLoaderDisplay(false);
			if (res.status !== 200) return;
			toast.success("Success", {
				position: toast.POSITION.TOP_RIGHT,
			});
			getDataViewData(filter);
			// onDataUpdate();
			handleModalClose();
		}).catch((error) => {
			setLoaderDisplay(false);
			handleModalClose();
		});
	}

	const showAttachedFiles = () => {
		return (
			<>
				{
					selectedBranchData.valueBeforeConversion && selectedBranchData.uomBeforeConversion &&
					<>
						<div className="p-1">
							<div>
								<label className='mb-1'><b>Input: </b>
									{`${Utils.formattedNumber(selectedBranchData.valueBeforeConversion)} ${selectedBranchData.uomBeforeConversion}`}
									{
										selectedBranchData.uomBeforeConversion !== selectedDp.unit &&
										<span className='text-muted mx-1'>{`(${Utils.formattedNumber(selectedBranchData.value)} ${selectedDp.unit})`}</span>
									}
								</label>
							</div>
							{
								selectedBranchData.emissionLinked &&
								<>
									<div>
										<label className='mb-1'><b>Emission Factor:</b> {`${Utils.formattedNumber(selectedBranchData.emissionFactor)}`}</label>
									</div>
									<div>
										<label className='mb-1'><b>Emission:</b> {`${Utils.formattedNumber(selectedBranchData.emissionValue)}`} kg CO2e</label>
									</div>
								</>
							}
						</div>
						<hr />
					</>
				}
				{
					selectedBranchData.value && selectedBranchData.activity
						?
						<>
							<div className="p-1">
								<label className='mb-1'><b>Log Information</b></label>
								<div>Source: {selectedBranchData?.activity?.source}</div>
								<div>Last Modified by: {selectedBranchData?.activity?.lastModifiedBy}</div>
								<div>Date: {moment(selectedBranchData?.activity?.lastModifiedDate).format("MMM Do YYYY, h:mm a")}</div>
							</div>
							<hr />
						</>
						:
						''
				}
				<div className="p-1">
					<label className='mb-1'><b>	{t("Comments.label")}</b></label>
					{
						dpComments &&
						<p>{dpComments}</p>
					}
					{
						!dpComments &&
						<p><FcFinePrint className="me-2" /> No comments added</p>
					}
				</div>
				<hr />
				<div className="p-1">
					<label className='mb-1'><b>{t("Documents&File.label")}</b></label>
					<div className='attachedFiles_box p-1 1'>
						{attachedFiles?.length === 0 && noAttachmentLabel()}
						{
							attachedFiles.map((files, index) => {
								return (
									<div className="attachedFiles_boxIn">
										<span className="attach_icon"><BsFileEarmarkFill /></span>
										{files.name}
										<span className="attach_Closeicon" onClick={() => downloadAttchement(files.externalId)}>
											<BsDownload />
										</span>
									</div>
								);
							})
						}
					</div>
				</div>
			</>
		);
	}

	const showConfirm = (data) => {
		setMessageConfirmation(t("DeleteFileConfirmationMessage.label"));
		setSelectedFile(data)
		setShowConfirmation(true);
	}

	const confirmDelete = (val) => {
		setShowConfirmation(false);
		if (val) {
			deleteFile(selectedFile.id);
		}
	};

	const deleteFile = (id) => {
		const index = tempAttachments.findIndex(x => x.id === id);
		if (index >= 0) {
			tempAttachments.splice(index, 1);
			let files = JSON.stringify(tempAttachments)
			setTempAttachments(JSON.parse(files));
		}
	}

	const downloadAttchement = (id) => {
		setLoaderDisplay(true);
		SubStdService.getDocumentsAttached(id)
			.then((response) => {
				setLoaderDisplay(false);
				let fetchDataModified = `data:${response.data.mimeType};base64,${response.data.file}`;
				let link = document.createElement("a");
				link.href = fetchDataModified;
				link.download = response.data.name;
				link.click();
			})
			.catch((error) => {
				setLoaderDisplay(false);
				console.log(error);
			});
	}

	const setupEdit = () => {
		setIsCommentEdit(true);
		let files = JSON.stringify(attachedFiles)
		setTempAttachments(JSON.parse(files));
		setTempComments(dpComments);
	}

	const cancelEdit = () => {
		setIsCommentEdit(false);
		setTempAttachments([]);
		setTempComments('');
		fileInputRef.current.value = null;
	};

	const renderQuantitativeTabContent = () => {
		return (
			<div>
				<div className="table-holder table-responsive mt-0">
					<Table responsive="sm" bordered >
						{renderTableHeader()}
						<tbody>
							{dataViewData?.length === 0 && renderEmptyDataLabel()}
							{
								dataViewData?.length > 0 &&
								dataViewData?.map((topic, tIndex) => {
									return (
										hasQuantitativeMetrics(topic.metricData)
											?
											<>
												{renderTopicRow(topic, tIndex)}
												{
													topic.metricData?.length > 0 &&
													topic.metricData?.map((metric, mIndex) => {
														return (
															<>
																{renderMetricRow(metric, mIndex, topic.topicId)}
																{renderDataPointRows(metric.id)}
															</>
														);
													})
												}
											</>
											: <></>
									);
								})
							}
						</tbody>
					</Table>
				</div>
				{
					showBranchDPSaveButton &&
					<div className="p-2 text-center DataView_tableSave">
						<button type="button"
							onClick={() => {
								saveMetricDataPoint();
								saveBranchDataPoint();
							}}
							className="btn btn-primary ms-2 px-4 sbmBtn">
							{t("Save.label")}
						</button>
					</div>
				}
			</div>
		);
	};

	const renderCommentsAndDocumentsModal = () => {
		return (
			<Modal show={showModal}
				onHide={handleModalClose}
				size="lg"
				aria-labelledby="contained-modal-title-vcenter"
				centered backdrop="static"
				keyboard={false}>
				<Modal.Header closeButton>
					 <Modal.Title as="h5">
						{selectedBranchData.emissionLinked ? selectedBranchData.dpName : t("CommentsandDocumentsFile.label")}
					</Modal.Title>
				</Modal.Header>

				<Modal.Body>
					{isCommentEdit &&
						<div>
							<div className='p-1'>
								<label className='mb-1'>
									{t("Comments.label")}
								</label>
								<textarea className='form-control' rows="5" value={tempComments} placeholder="Provide your comments here"
									onChange={(e) => { setTempComments(e.target.value) }}></textarea>
							</div>
							<div className='p-1'>
								<label className='mb-1'>Upload files</label>
								<div className='d-flex'>
									<input
										className='form-control'
										type="file"
										id="imageUpload"
										accept=".pdf, .docx, .png, .jpg, .xls, .xlsx"
										onChange={(e) => handleFileSelect(e)}
										onClick={(e) => {
											e.target.value = null;
										}}
										ref={fileInputRef}
									/>
									{/* <Button variant="primary" className="sbmBtn ms-2" onClick={() => { uploadAttachments() }}>
										{t("Upload.label")}
									</Button> */}
								</div>
								<div className='attachedFiles_box p-1 2'>
									{
										tempAttachments.map((files, index) => {
											return (
												<div className="attachedFiles_boxIn">
													<span className="attach_icon"><BsFileEarmarkFill /></span>
													{files.name}
													<span className="attach_Closeicon " onClick={() => showConfirm(files)}>
														<BsX />
													</span>
												</div>
											);
										})
									}
								</div>
							</div>
						</div>
					}

					{!isCommentEdit &&
						showAttachedFiles()
					}
				</Modal.Body>
				<Modal.Footer>
					{
						isCommentEdit &&
						<>
							<Button variant="secondary" onClick={() => cancelEdit()}>
								{t("Cancel.label")}
							</Button>
							<Button variant="primary" className="sbmBtn" onClick={() => saveCommentsAndFiles()}>
								{t("Update.label")}
							</Button>
						</>
					}
					{
						!isCommentEdit &&
						<>
							<Button variant="secondary" onClick={() => handleModalClose()}>
								{t("Close.label")}
							</Button>
							<Button variant="primary" className="sbmBtn" onClick={() => setupEdit()}>
								{t("Edit.label")}
							</Button>
						</>
					}
				</Modal.Footer>
			</Modal>
		)
	};

	const renderGHGEmissionTooltip = (metric) => {
		return (
			<Tooltip className="mytooltip">
				<label>{t("ViewUpdateGHGDataCollectionToolTip.label")}</label>
			</Tooltip>
		);
	}

	const gotoEditGHGData = () => {
		navigate({
			pathname: "/company_admin/editGHGData",
		});
	}

	return (
		<div id='dataViewHolder'>
			<div className="List_header mb-1">
				<div>
					<h5 className="MH">{t("Periodic.label")}</h5>
				</div>
				<DataViewHeaderActions
					filter={filter}
					regulationId={glbRegulationId}
					view={view}
					viewType={viewType}
					goalId={goalId}
					onFilterClick={() => setShowFilter(!showFilter)}
					onViewChange={(v) => {
						setView(v);
						setKey('quan');
						const f = {
							...filter,
							periodFrom: v === 'CONSOLIDATED_VIEW' ? `${year}-01-01` : null,
							periodTo: v === 'CONSOLIDATED_VIEW' ? `${year}-12-31` : null
						};
						if (v != 'COMPARE') {
							applyFilter(f);
						}
					}}
					onViewTypeChange={(v) => setViewType(v)} />

			</div>
			{
				view != 'COMPARE' &&
				<div className={showFilter ? '' : 'd-none'}>
					<DataViewFilter view={view}
						dataViewType={viewType}
						yearFilter={yearFilter}
						goalId={goalId}
						onApplyFilter={(f) => applyFilter(f)}
						onResetFilter={() => resetData()}
						viewFilter={showFilter}
						onFilterHide={(value) => setShowFilter(value)} />
				</div>
			}
			{view !== 'COMPARE' && renderDataViewTable()}
			{view === 'COMPARE' && <CompareDataView viewFilter={showFilter} viewType={viewType}
				onViewChange={(v) => setView(v)}
				onViewTypeChange={(v) => setViewType(v)} hideFilter={(value) => setShowFilter(value)} />}
			{viewType === 'KPI' && view === 'ACTIONS_VIEW' && <KPIActionsView filter={filter} />}
			{
				editedBranch !== null &&
				<ConfirmationModal
					modalShow={editedBranch !== null}
					id={editedBranch}
					title={t("confirmation.label")}
					messageText={"Do you want to save the changes?"}
					callbackModal={saveChangesConfirmationCallBack}

					confirmBtn={t("Save")}
					CancelBtn={t("Don't Save")}
				/>
			}
			{
				showConfirmation &&
				<ConfirmationModal
					modalShow={true}
					messageText={messageConfirmation}
					callbackModal={confirmDelete}
					confirmBtn={t("Confirm.label")}
					CancelBtn={t("Cancel.label")}
				/>
			}
			{renderCommentsAndDocumentsModal()}
		</div>
	);
};

export default withTranslation()(DataViewReporting);